import { useRef, useEffect, useState } from 'react';

export function VideoMontage() {
  const videoRef = useRef(null);
  const [mediaLoaded, setMediaLoaded] = useState(false);
  const [useImage, setUseImage] = useState(false);

  useEffect(() => {
    // Try to play video
    if (videoRef.current && !useImage) {
      const playPromise = videoRef.current.play();
      
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            setMediaLoaded(true);
          })
          .catch(() => {
            // If video fails, fallback to image
            setUseImage(true);
            setMediaLoaded(true);
          });
      }

      // Set timeout fallback - if video doesn't load in 3 seconds, use image
      const timeout = setTimeout(() => {
        if (!mediaLoaded) {
          setUseImage(true);
          setMediaLoaded(true);
        }
      }, 3000);

      return () => clearTimeout(timeout);
    }
  }, [useImage, mediaLoaded]);

  return (
    <div className="absolute inset-0 overflow-hidden">
      {/* Hero Video - attempt to load */}
      {!useImage && (
        <video
          ref={videoRef}
          autoPlay
          loop
          muted
          playsInline
          onError={() => setUseImage(true)}
          onLoadedData={() => setMediaLoaded(true)}
          className="absolute inset-0 w-full h-full object-cover"
          preload="metadata"
        >
          <source src="/assets/hero-video.mp4" type="video/mp4" />
        </video>
      )}

      {/* Fallback hero image - professional production photo */}
      {useImage && (
        <img 
          src="/assets/mexico/crew-02.jpg" 
          alt="Baklight film production crew on set in Mexico"
          className="absolute inset-0 w-full h-full object-cover"
          onLoad={() => setMediaLoaded(true)}
        />
      )}

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-[hsl(222,18%,4%)] via-[hsl(222,18%,6%)]/90 to-transparent" />
    </div>
  );
}
